import { AavoContextMenuItem } from "src/components/common/contextMenu/AavoContextMenuItem";
import {
	DocumentsOfObjectButton,
	DocumentsOfObjectButtonProps,
} from "src/components/views/documents/objectDocuments/DocumentsOfObjectButton.tsx";

export const DocumentsOfObjectContextMenuButton = (props: DocumentsOfObjectButtonProps) => {
	return (
		<AavoContextMenuItem>
			<DocumentsOfObjectButton {...props} color="inherit" />
		</AavoContextMenuItem>
	);
};
